import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

export interface ModalComponentData {
  title: string;
  subtitle: string;
  payload: string | boolean | Record<string, any>;
  cancelBtnText?: string;
  okBtnText?: string;
  primaryBtn?: string;
}

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalComponent {

  constructor(
    public dialogRef: MatDialogRef<ModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalComponentData
  ) {
  }

  public onOkClick(): void {
    this.dialogRef.close(this.data.payload);
  }

}
